import { AddCommentOutlined as AddCommentIcon } from '@mui/icons-material';
import { type IconButtonProps } from '@mui/material';
import styled from '@emotion/styled';
import emotionFirstChildSelector, {
  suppressEmotionFirstChildSelectorWarning,
} from '@/lib/styling/emotionFirstChildSelector';
import { FormattedMessage } from 'react-intl';
import isTouchDevice from '@/lib/utils/isTouchDevice';
import TonalButton from '@/components/TonalButton';

const StyledButton = styled(TonalButton)(
  ({ theme }) => ({
    paddingLeft: 24,
    paddingRight: 24,
    transition: theme.transitions.create([
      'margin-top',
      'opacity',
      'background-color',
      'height',
    ]),
    [emotionFirstChildSelector]: {
      marginLeft: -32,
    },
    '.MuiButton-loadingIndicator': {
      paddingLeft: 16,
    },
  }),
  () => {
    if (isTouchDevice()) {
      return {
        opacity: '1 !important',
        height: '36.5px !important',
        [`:not(:first-child) ${suppressEmotionFirstChildSelectorWarning}`]: {
          marginTop: '12px !important',
        },
      };
    }
  },
);

type AddCoachCommentButtonProps = Omit<
  IconButtonProps,
  'className' | 'color' | 'children'
>;

const AddCoachCommentButton = (props: AddCoachCommentButtonProps) => (
  <StyledButton
    className="add-coach-comment-button"
    color="secondary"
    startIcon={<AddCommentIcon />}
    loadingPosition="start"
    {...props}
  >
    <FormattedMessage id="portfolio.challenge.coach_comments.add.button" />
  </StyledButton>
);

export default AddCoachCommentButton;
